/**
 * 『コマ割』画面に引き渡す値を格納するVO
 *
 * @export KYMW1404OutPutModel
 * @class KYMW1404OutPutModel
 */
export class KYMW1404OutPutModel {
  /**
   * 処理区分
   * 1:コマ配置、2:アクティブなコマに配置、3:ドラッグ＆ドロップ完了時
   */
  public processDiv: number = null;

  /**
   * Ｐコード
   */
  public pcode: Array<any> = new Array<any>();

  /**
   * 候補商品VO.
   */
  public goodsData: Array<any> = new Array<any>();

  /**
   * 注文商品区分
   */
  public orderGoodsFlg = String('');
}
